import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Canceler } from 'axios';

import { IProfile, IProfileState } from './types';

import New from './components/New';
import Edit from './components/Edit';
import Subpage from '../components/Subpage';
import API from 'src/services/api';

class Profiles extends React.Component<RouteComponentProps, IProfileState> {
  reqCanceler: Canceler | null = null;

  state: IProfileState = {
    items: [],
    isLoading: true,
  };

  columns = ['Name', 'Shortener whitelist', 'Shortener blacklist', 'Status'];

  getColumnValues = (profile: IProfile) => [
    profile.name,
    profile.shortDomainWhitelisted,
    profile.shortDomainNonWhitelisted,
    profile.active ? 'Active' : 'Inactive',
  ];

  async componentDidMount() {
    const { getData, cancel } = API.ADMIN.PROFILES.getAll();
    this.reqCanceler = cancel;
    const items = await getData();
    this.setState({ items, isLoading: false });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  add = async (profile: IProfile) => {
    const newUser = await API.ADMIN.PROFILES.add(profile);
    this.setState(({ items }) => ({
      items: [newUser, ...items],
    }));
  };

  update = async (profile: IProfile) => {
    const updatedProfile = await API.ADMIN.PROFILES.update(profile);
    this.setState(({ items }) => {
      const profileIndex = items.findIndex(
        (item) => item.id === updatedProfile.id
      );
      return {
        items: [
          ...items.slice(0, profileIndex),
          updatedProfile,
          ...items.slice(profileIndex + 1),
        ],
      };
    });
  };

  getSearchString = (user: IProfile) => user.name;

  NewForm = (props: any) => {
    return <New add={this.add} allItems={this.state.items} {...props} />;
  };

  EditForm = (props: any) => {
    return <Edit update={this.update} allItems={this.state.items} {...props} />;
  };

  render() {
    return (
      <Subpage
        currentPath={this.props.location.pathname}
        NewForm={this.NewForm}
        EditForm={this.EditForm}
        columns={this.columns}
        getColumnValues={this.getColumnValues}
        getSearchString={this.getSearchString}
        items={this.state.items}
        isLoading={this.state.isLoading}
      />
    );
  }
}

export default Profiles;



// WEBPACK FOOTER //
// ./src/views/Admin/Profiles/Profiles.tsx